import React from "react";

/**
 * Off-screen honeypot. Do not use display:none — simple bots skip those.
 */
export default function HoneypotField({ value, onChange, id = "website_url_hp" }) {
  return (
    <div
      className="absolute -left-[9999px] top-auto h-0 w-0 overflow-hidden opacity-0"
      aria-hidden="true"
    >
      <label htmlFor={id}>Website</label>
      <input
        id={id}
        name="website_url_hp"
        type="text"
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={onChange}
      />
    </div>
  );
}
